var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrderIconBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80.75 80.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#fff;stroke-miterlimit:20;stroke-width:3.25px;}.cls-2{fill:none;stroke:#026ce3;stroke-linecap:round;stroke-linejoin:round;stroke-width:2.88px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m40.37,79.12c21.4,0,38.75-17.35,38.75-38.75S61.77,1.62,40.37,1.62,1.62,18.97,1.62,40.37s17.35,38.75,38.75,38.75Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 18.75,
    y: 18.75,
    width: 43.24,
    height: 43.24,
    rx: 2.88,
    ry: 2.88
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "40.37 25.96 31.72 37.49 25.96 31.72"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 44.7,
    y1: 33.17,
    x2: 53.35,
    y2: 33.17
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "40.37 43.26 31.72 54.79 25.96 49.02"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 44.7,
    y1: 50.46,
    x2: 53.35,
    y2: 50.46
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderIconBlue);
export default __webpack_public_path__ + "static/media/OrderIconBlue.2faf36d31a51c71b6ccca51d3290afb2.svg";
export { ForwardRef as ReactComponent };